export const appBuildAssetsDir = "/_nuxt/1767354664771/"

export const appHead = {"meta":[{"charset":"utf-8"},{"name":"google-site-verification","content":"Rngsu4GvorQORFmjXOGM6mvzvfXNXhRRQnVDEMTWaP4"},{"name":"google-site-verification","content":"sLW7V50Dnjhi9gIwpytwMNMMYkX0XpYdReNWi0AX--A"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"description","content":"Gaudeix dels millors esdeveniments esportius en directe, des de qualsevol disposition i en qualsevol moment."},{"name":"keywords","content":null},{},{"property":"og:title","content":"ESPORT+"},{"property":"og:type","content":"article"},{"property":"og:image","content":"https://www.esportplus.tv/images/customer/metaImage.png"},{"property":"og:image:width","content":"1200"},{"property":"og:image:height","content":"630"},{"property":"og:description","content":"Gaudeix dels millors esdeveniments esportius en directe, des de qualsevol disposition i en qualsevol moment."},{"property":"og:site_name","content":"ESPORT+"},{"property":"og:url","content":"https://www.esportplus.tv"},{"property":"article:published_time","content":"1/2/2026"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:site","content":"https://twitter.com/esportplustv/"},{"name":"twitter:title","content":"ESPORT+"},{"name":"twitter:description","content":"Gaudeix dels millors esdeveniments esportius en directe, des de qualsevol disposition i en qualsevol moment."},{"name":"twitter:image:src","content":"https://www.esportplus.tv/images/customer/metaImage.png"},{"name":"twitter:image:alt","content":"/images/customer/metaImage.png image"},{"name":"apple-itunes-app","content":"app-id=1594393562, app-argument=https://www.esportplus.tv"},{"property":"fb:app_id","content":"533928598210049"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/images/customer/favicon.png"}],"style":[{"innerHTML":"\n              :root {\n                --base-customer-color: #DA2329;\n                --base-primary-accent-color: #DA2329;\n              }\n            "}],"script":[{"async":"","src":"https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8370503427169415","crossorigin":"anonymous","innerHTML":""},{"id":"imaSDK","type":"text/javascript","src":"https://imasdk.googleapis.com/js/sdkloader/ima3.js"},{"type":"text/javascript","src":"https://www.gstatic.com/cv/js/sender/v1/cast_sender.js?loadCastFramework=1"}],"noscript":[],"title":"ESPORT+"}

export const appBaseURL = "/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":false}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = true

export const purgeCachedData = true

export const granularCachedData = true

export const pendingWhenIdle = false

export const alwaysRunFetchOnKeyChange = false